import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/ContactUs";
import ListSection from "../../components/ListSection";
import { getAccessRights } from "../../utils/common";
import { useHistory } from "react-router-dom";
import { pluck } from "underscore";
import DeleteModel from "../../components/DeleteModel";
function ModuleList() {
  const [isLoader, setIsLoader] = useState(false);
  const [accessRights, setAccessRights] = useState();
  const [ids, setIds] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const columns = [
    { title: "ID", field: "contact_us_id" },
    {
      title: "Name",
      field: "first_name",
      render: (rowData) => (
        <span>
          {rowData.first_name} {rowData.last_name}
        </span>
      ),
    },
    { title: "Email", field: "email" },
    {
      title: "User Type",
      field: "user_type",
      render: (rowData) => (
        <span className="capitalize">{rowData.user_type}</span>
      ),
    },
    { title: "Message", field: "message" },
    { title: "Date", field: "created_at" },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "complete"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800"
          }
        >
          {" "}
          {rowData.status === "complete" ? "Complete" : "Pending"}
        </span>
      ),
    },
  ];
  const [data, setData] = useState([]);
  const history = useHistory();

  const onSelectionChange = (e) => {
    let idArr = pluck(e, "contact_us_id");
    setIds(idArr);
  };
  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "CONTACT_US");
      setAccessRights(rightsData);
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });
    getData();
  }, []);

  function getData() {
    setIsLoader(true);
    configuration
      .getAPI({
        url: "common/list-ticket",
        params: {},
      })
      .then((data) => {
        if (data.status === 200) {
          setData(data.payload);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  function handleAction(type) {
    if (ids.length < 1) {
      return toast.error("Please select at least one record");
    } else if (type === "delete") {
      setShowModal(true);
      return;
    }
    const sendData = {
      ids,
      type:
        type === "makeComplete"
          ? "complete"
          : type === "makePending"
          ? "pending"
          : type,
    };
    configuration
      .postAPI({ url: "common/ticket-action", params: sendData })
      .then((data) => {
        if (data.status === 200) {
          setIds([]);
          getData();
          return toast.success(
            type === "delete"
              ? "Record deleted successfully"
              : "Record update successfully"
          );
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  const btnGroups = [
    {
      id: 2,
      title: "Make Complete",
      type: "makeComplete",
      path: "/contactUs",
      key: "edit",
    },
    {
      id: 3,
      title: "Make Pending",
      type: "makePending",
      path: "/contactUs",
      key: "edit",
    },
    {
      id: 5,
      title: "Delete",
      type: "delete",
      path: "/contactUs",
      key: "delete",
    },
  ].filter((btn) => accessRights?.[btn.key]);

  function handleDelete() {
    const sendData = {
      ids,
      type: "delete",
    };
    configuration
      .postAPI({ url: "common/ticket-action", params: sendData })
      .then((data) => {
        if (data.status === 200) {
          setIds([]);
          getData();
          handleCancel();
          return toast.success("Record deleted successfully");
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  function handleCancel() {
    setShowModal(false);
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.ContactUs} />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <ListSection
        captionTitle="View Contact Us"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
        // is_pagenation={true}
      />
    </>
  );
}

export default ModuleList;
